import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaEquipoTalentoHumano from "./CreaEquipo/CreaEquipoTalentoHumano";
import Cookies from "universal-cookie";

function EquipoTalentoHumano({ idSolicitud }) {
  const cookies = new Cookies();

  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  const obtenerDatos = () => {
    axios
      .get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoTalentoHumanoPorSolicitudId?SolicitudId=${idSolicitud}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      )
      .then((res) => setList(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    obtenerDatos();
  }, [idSolicitud]);

  const eliminarRegistro = (id) => {
    if (!window.confirm("¿Eliminar este registro?")) return;

    axios
      .delete(
        `https://suadesarrollo.azurewebsites.net/api/eliminarEquipoTalentoHumanoPorId?Id=${id}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
          data: {
            tipoAccion: "Eliminación equipo talento humano",
            idUsuario: cookies.get("id"),
          },
        },
      )
      .then(() => {
        alert("Registro eliminado");
        obtenerDatos();
      })
      .catch(() => alert("Error al eliminar"));
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const currentItems = list.slice(
    indexOfLastItem - itemsPerPage,
    indexOfLastItem,
  );

  return (
    <div className="container">
      <div className="card shadow">
        <div className="card-header">
          <h6 className="text-primary font-weight-bold">
            Equipo Talento Humano
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta === "ProcesoAutoevaluacion" && (
              <CreaEquipoTalentoHumano
                idSolicitud={idSolicitud}
                onCreated={obtenerDatos}
              />
            )}

          <table className="table table-bordered mt-3">
            <thead>
              <tr>
                <th>Id</th>
                <th>Nombre</th>
                <th>Área</th>
                <th>Cargo</th>
                <th>Líder</th>
                <th>Antiguedad</th>
                <th>SolicitudId</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nombre}</td>
                    <td>{item.area}</td>
                    <td>{item.cargo}</td>
                    <td>{item.lider}</td>
                    <td>{item.antiguedad}</td>
                    <td>{item.solicitudId}</td>
                    <td>
                      {cookies.get("tipo_Usuario") == 2 &&
                        nombreRuta === "ProcesoAutoevaluacion" && (
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => eliminarRegistro(item.id)}
                          >
                            Eliminar
                          </button>
                        )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No hay registros
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <ul className="pagination">
            {list.length > itemsPerPage &&
              Array.from(
                { length: Math.ceil(list.length / itemsPerPage) },
                (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ),
              )}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default EquipoTalentoHumano;
